import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { useServices } from "@website/widget/header";

export function TravelServicesDesktop() {
  const { services } = useServices();
  return (
    <div className="group relative hidden h-full items-center lg:flex">
      <Button
        className="!mx-0"
        EndIcon={<MaterialIcon name="keyboard_arrow_down" />}
        aria-label="خدمات مسافرتی"
        color="neutral"
        size="medium"
        variant="text"
      >
        خدمات مسافرتی
      </Button>
      <section className="invisible absolute top-0 z-50 size-auto translate-y-20 py-1 opacity-0 transition-all duration-75 ease-in-out group-hover:visible group-hover:top-[56px] group-hover:translate-y-2 group-hover:opacity-100">
        <div className="elevation-8 size-auto rounded-lg">
          <div className="w-[280px] rounded-lg p-2">
            {services.map((item) => (
              <a
                className="hover:bg-states-neutral-hover flex h-12 items-center justify-start gap-2 rounded-lg px-1 transition-all"
                href={item.url}
                key={item.title}
              >
                <span className="text-on-surface-medium-emphasis text-2xl">
                  {item.icon}
                </span>
                <div className="text-button text-on-surface-high-emphasis">
                  {item.title}
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
